import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    isLoggedIn: false,
    loading: false,
    error: null,
    inboxUnreadCount: 0,
    leadInboxUnreadCount: 0,
    ticketUnreadCount: 0,
    sidebarCollapsed: false,
    lastInboxEvent: null,
  },
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      // console.log(action, "action");
      state.loading = false;
      state.isLoggedIn = true;
      state.user = action.payload;
      state.error = null;
    },
    loginFailure: (state, action) => {
      // console.log(action, "action");
      state.loading = false;
      state.isLoggedIn = false;
      state.user = null;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.error = null;
    },
    updateMenuAccess: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, menu_access: action.payload };
      }
    },
    setInboxUnreadCount: (state, action) => {
      state.inboxUnreadCount = action.payload;
    },
    setLeadInboxUnreadCount: (state, action) => {
      state.leadInboxUnreadCount = action.payload;
    },
    setTicketUnreadCount: (state, action) => {
      state.ticketUnreadCount = action.payload;
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
    pushInboxEvent: (state, action) => {
      state.lastInboxEvent = action.payload; // screens react via useSelector
    },
  },
});

export const { loginRequest, loginSuccess, loginFailure, logout, updateMenuAccess, setInboxUnreadCount, setLeadInboxUnreadCount, setTicketUnreadCount, setSidebarCollapsed, pushInboxEvent } =
  authSlice.actions;
export const selectInboxUnreadCount = (state) => state.user.inboxUnreadCount;
export const selectLeadInboxUnreadCount = (state) => state.user.leadInboxUnreadCount;
export const selectTicketUnreadCount = (state) => state.user.ticketUnreadCount;
export const selectUser = (state) => state.user.user;
export const selectSidebarCollapsed = (state) => state.user.sidebarCollapsed;
export const selectLastInboxEvent = (state) => state.user.lastInboxEvent;
export const isLoggedIn = (state) => state.user.isLoggedIn;
export default authSlice.reducer;
